:host {
  display: inline-flex;
  align-items: center;
  cursor: default;
}
